<template>
    <div class="bg-white rounded">
        <div
            class="flex"
            :class="{ 'cursor-pointer': hasSlotContent() }"
            @click="toggle"
        >
            <span v-if="icon" class="icon-circle bg-neutral-lightest mr-xl">
                <font-awesome-icon :icon="icon" />
            </span>

            <div class="pt-xs">
                <slot name="title" />
            </div>

            <div v-if="hasSlotContent()" class="ml-auto pt-sm">
                <font-awesome-icon v-if="toggled" icon="chevron-up" />
                <font-awesome-icon v-else icon="chevron-down" />
            </div>
        </div>
        <div v-if="toggled" class="py-md">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            icon: {
                type: Array,
                default: null,

            },
            toggledOnLoad: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                toggled: this.toggledOnLoad,
            };
        },

        methods: {
            hasSlotContent() {
                return !! this.$slots.default;
            },

            toggle() {
                if (! this.hasSlotContent()) {
                    return;
                }
                this.toggled = ! this.toggled;
            },
        },
    };
</script>
